export const salarios = [
    { label: '1 a 2 SALARIOS MINIMOS MENSUALES', value: '1' },
    { label: '2 A 3 SALARIOS MINIMOS MENSUALES ', value: '2' },
    { label: '3 A 4 SALARIOS MINIMOS MENSUALES', value: '3' },
    { label: '4 A 5 SALARIOS MINIMOS MENSUALES', value: '4' },
    { label: '5 A 6 SALARIOS MINIMOS MENSUALES', value: '5' },
    { label: '6 A 7 SALARIOS MINIMOS MENSUALES', value: '6' },
    { label: '7 A 8 SALARIOS MINIMOS MENSUALES', value: '7' },
    { label: '8 A 9 SALARIOS MINIMOS MENSUALES', value: '8' },
    { label: '9 A 10 SALARIOS MINIMOS MENSUALES', value: '9' },
    { label: '10 A 11 SALARIOS MINIMOS MENSUALES', value: '10' },
    { label: '11 A 12 SALARIOS MINIMOS MENSUALES', value: '11' },
    { label: '12 A 13 SALARIOS MINIMOS MENSUALES', value: '12' },
    { label: '13 A 14 SALARIOS MINIMOS MENSUALES', value: '13' },
    { label: '14 O MAS SALARIOS MINIMOS MENSUALES', value: '14' }
]